import { render, staticRenderFns } from "./wechatCallback.vue?vue&type=template&id=7573f5c8"
import script from "./wechatCallback.vue?vue&type=script&lang=js"
export * from "./wechatCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports